// libs
import React from 'react';

import { cn } from '@lyearn/style';
// components
import CellBackdrop from '@/modules/corporate/modules/database/fields/components/CellBackdrop';
// styles
import { rectPositionStyles } from '@/modules/corporate/modules/database/fields/text/styles';
// types
import { CellProps } from '@/modules/corporate/modules/database/types';

import { TableViewActionTypes } from '../../views/TableView/hooks/useTableViewActions/actions';
import RatingInput from './components/RatingInput';
import { getRatingMaxValue } from './consts';
import { ratingCellInputStyles } from './styles';

function RatingEditable(props: CellProps) {
  const { toggleIsEditing, cellData, onAction, column, rowData } = props;
  const maxValue = getRatingMaxValue(column.field.metadataField.validation?.maxValue);

  const onChange = (_: React.ChangeEvent<{}>, value: string | null) => {
    if (!value) {
      return;
    }
    onAction({
      type: TableViewActionTypes.UpdateCellValue,
      payload: {
        fieldId: column.id,
        documentId: rowData._id,
        data: { value },
      },
    });
    toggleIsEditing();
  };

  return (
    <CellBackdrop onClickAway={toggleIsEditing}>
      {(rect) => (
        <RatingInput
          openOnFocus
          className={cn('fixed', rectPositionStyles(rect), ratingCellInputStyles)}
          max={maxValue}
          value={cellData?.value || ''}
          onChange={onChange}
        />
      )}
    </CellBackdrop>
  );
}

export default RatingEditable;
